import styled, { css } from "styled-components";
import { inactiveItens, primary } from "../../../../theme";
import { IThemeProps, themeTypes } from "../../../../interfaces";

export const Container = styled.div<IThemeProps>`
    display: flex;
    padding: 20px;
    gap: 20px;
    padding-top:10px;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background: #FFF;
    position: relative;
    border-radius: 0.3125rem;
    outline: 0;
    min-width:90vw;
    max-width:90vw;
    @media (min-width: 650px) {
        min-width:600px;
        max-width:600px;
    }
    ${props => css`
        background: ${primary[props.theme as themeTypes]};
        color: ${inactiveItens[props.theme as themeTypes]};
    `}
`

export const ContainerText = styled.div`
    display:flex;
    flex-direction:column;
    align-items:center;
`

export const Title = styled.div`
    font-size:22px;
    font-weight: 600;
`

export const Description = styled.div`
`

export const ContainerButton = styled.div`
    display:flex;
    flex-direction:row;
`

export const Button = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    color:#FFF;
    padding:8px;
    border-radius:0.3125rem;
    min-width:6.25rem;
    justify-content:center;
    margin-right:0.3125rem;
    cursor: pointer;
`